import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setUserPaymentPath } from '../../features/userPayments/userPaymentSlice';

function INCSUBUserPaymentDetailCard({info}) {
  
    const selectedPayment = useSelector((state) => state.userPayment.selectedPayment);
  const dispatch = useDispatch();
  const formatDateTime = (dateTime) => {
    const date = new Date(dateTime);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    const formattedDate = date.toLocaleDateString("en-GB", options).replace(",", "");
    const hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const period = hours >= 12 ? "PM" : "AM";
    const formattedTime = `${hours % 12 || 12}:${minutes} ${period}`;

    return `${formattedDate} ${formattedTime}`;
  };

  return (
    <div className='INCSUBPoolInfo_card'>
      <div className='INCSUBPoolInfo_card_poolname_status_validity'>
        <div className='INCSUBPoolInfo_card_poolname_type'>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ cursor: 'pointer' }} onClick={() => {
            dispatch(setUserPaymentPath("/userPayment"))
          }}>
            <path d="M19 12H5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M12 19L5 12L12 5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>

          {/* <div className='INCSUBPoolInfo_card_poolname'>{"ABCD"}</div>
          <div className='INCSUBPoolInfo_card_pooltype'>{"Active"}</div> */}
        </div>
      </div>
      <div className='INCSUBPoolInfo_card_pool_details'>
        <div className='INCSUBPoolInfo_card_pool_details_divs'>
          <div className='INCSUBPoolInfo_card_pool_details_name_img'>
            {/* <div className='INCSUBPoolInfo_card_pool_details_hostedby_img'>
              <img className='INCSUB_UserImgTag' src={selectedPayment?.userImage?selectedPayment?.userImage:'/assets/icons/common/defaultImage.png'} alt={`${'default'} img`} />
            </div> */}
            <div className='INCSUBPoolInfo_card_pool_details_hostedby_name'>
              <p className='INCSUBPoolInfo_card_pool_details_hostedby_p'>Name</p>
              <p className='INCSUBPoolInfo_card_pool_details_hostedbyname_p'>{selectedPayment?.userFullName}</p>
            </div>
          </div>
        </div>
        <div className='INCSUBPoolInfo_card_pool_details_divs'>
          <div className='INCSUBPoolInfo_card_pool_details_name_img'>
            <div className='INCSUBPoolInfo_card_pool_details_hostedby_name'>
                    <p className='INCSUBPoolInfo_card_pool_details_hostedby_p'>Mobile No</p>
              <p className='INCSUBPoolInfo_card_pool_details_hostedbyname_p'>{selectedPayment?.userMobileNumber}</p>
            </div>
          </div>
        </div>
        <div className='INCSUBPoolInfo_card_pool_details_divs'>
          <div className='INCSUBPoolInfo_card_pool_details_name_img'>
            <div className='INCSUBPoolInfo_card_pool_details_hostedby_name'>
              <p className='INCSUBPoolInfo_card_pool_details_hostedby_p'>Date</p>
              <p className='INCSUBPoolInfo_card_pool_details_hostedbyname_p'>{formatDateTime(selectedPayment?.requestCreatedAt)}</p>
            </div>
          </div>
        </div>
        <div className='INCSUBPoolInfo_card_pool_details_divs'>
          <div className='INCSUBPoolInfo_card_pool_details_name_img'>
            <div className='INCSUBPoolInfo_card_pool_details_hostedby_name'>
              <p className='INCSUBPoolInfo_card_pool_details_hostedby_p'>Pool Name</p>
              <p className='INCSUBPoolInfo_card_pool_details_hostedbyname_p'>{selectedPayment?.poolName}</p>
            </div>
          </div>
        </div>
        <div className='INCSUBPoolInfo_card_pool_details_divs'>
          <div className='INCSUBPoolInfo_card_pool_details_name_img'>
            <div className='INCSUBPoolInfo_card_pool_details_hostedby_name'>
              <p className='INCSUBPoolInfo_card_pool_details_hostedby_p'>Status</p>
              <p className={`INCSUBPoolInfo_card_pool_details_hostedbyname_p paymentVerification ${selectedPayment?.requestStatus}`}>{selectedPayment?.requestStatus}</p>
            </div>
          </div>
        </div>
        <div className='INCSUBPoolInfo_card_pool_details_divs_last'>
          <div className='INCSUBPoolInfo_card_pool_details_name_img'>
            <div className='INCSUBPoolInfo_card_pool_details_hostedby_name'>
        
              <p className='INCSUBPoolInfo_card_pool_details_hostedby_p'>Amount</p>
              <p className='INCSUBPoolInfo_card_pool_details_hostedbyname_p'>₹ {selectedPayment?.transactionAmount}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default INCSUBUserPaymentDetailCard;
